import { useCallback, useEffect, useState } from 'react';
const STORAGE_KEY = 'thousand-sunny:proposalProgressAutoHide';
const DEFAULT_AUTO_HIDE = true;
const CHANGE_EVENT = 'thousand-sunny:proposalProgressPreferencesChange';
function readAutoHide() {
    if (typeof window === 'undefined') return DEFAULT_AUTO_HIDE;
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (raw === null) return DEFAULT_AUTO_HIDE;
        return raw === 'true';
    } catch  {
        return DEFAULT_AUTO_HIDE;
    }
}
/**
 * User preference for whether the proposal progress bar auto-hides on completion.
 * Persists to localStorage. When false, the bar stays visible (in a "Completed" state)
 * until the user dismisses it manually.
 */ export function useProposalProgressPreferences() {
    const [autoHide, setAutoHideState] = useState(readAutoHide);
    useEffect(()=>{
        // Same handler covers both the same-tab custom event (Event) and the
        // cross-tab storage event (StorageEvent). For storage events, filter
        // by key so writes to unrelated localStorage entries don't re-read.
        function handleChange(event) {
            if (event instanceof StorageEvent && event.key !== null && event.key !== STORAGE_KEY) {
                return;
            }
            setAutoHideState(readAutoHide());
        }
        window.addEventListener(CHANGE_EVENT, handleChange);
        window.addEventListener('storage', handleChange);
        return ()=>{
            window.removeEventListener(CHANGE_EVENT, handleChange);
            window.removeEventListener('storage', handleChange);
        };
    }, []);
    const setAutoHide = useCallback((value)=>{
        try {
            window.localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
        } catch  {
        // Storage unavailable — fall back to in-memory state only
        }
        setAutoHideState(value);
        window.dispatchEvent(new Event(CHANGE_EVENT));
    }, []);
    return {
        autoHide,
        setAutoHide
    };
}
